export enum ESecondCategories {
  YEAR_REPORT = 'Raport Roczny',
  HALF_YEAR_REPORT = 'Raport Półroczny',
  QUARTER_REPORT = 'Raport Kwartalny',
  CURRENT_REPORT = 'Raport Bieżący',
  ARCHIVE = 'Archiwum',
  EXTRAORDINARY_ASSEMBLY = 'Zgromadzenie nadzwyczajne',
  ORDINARY_ASSEMBLY = 'Zgromadzenie zwyczajne',
  SIGNIFICANT_TRANSACTION = 'Istotna Transakcja',
  MERGER_OF_COMPANIES = 'Połączenie Spółek',
}

export enum ESecondCategoriesIds {
  YEAR_REPORT = 0,
  HALF_YEAR_REPORT = 1,
  QUARTER_REPORT = 2,
  CURRENT_REPORT = 3,
  ARCHIVE = 4,
  EXTRAORDINARY_ASSEMBLY = 5,
  ORDINARY_ASSEMBLY = 6,
  SIGNIFICANT_TRANSACTION = 7,
  MERGER_OF_COMPANIES = 8,
}

export const ESecondCategoriesLabels: Record<ESecondCategories, number> = {
  [ESecondCategories.YEAR_REPORT]: 0,
  [ESecondCategories.HALF_YEAR_REPORT]: 1,
  [ESecondCategories.QUARTER_REPORT]: 2,
  [ESecondCategories.CURRENT_REPORT]: 3,
  [ESecondCategories.ARCHIVE]: 4,
  [ESecondCategories.EXTRAORDINARY_ASSEMBLY]: 5,
  [ESecondCategories.ORDINARY_ASSEMBLY]: 6,
  [ESecondCategories.SIGNIFICANT_TRANSACTION]: 7,
  [ESecondCategories.MERGER_OF_COMPANIES]: 8,
}
